import { Heading3 } from 'elements/Typography';
import { ButtonExtraLarge } from 'elements/Forms';
import Outlook from '../../public/media/cta-icons/outlook.svg';
import Gmail from '../../public/media/cta-icons/gmail.svg';
import Salesforce from '../../public/media/cta-icons/salesforce.svg';
import LinkedIn from '../../public/media/cta-icons/linkedin.svg';
import Zoom from '../../public/media/cta-icons/zoom.svg';
import Teams from '../../public/media/cta-icons/teams.svg';

const PostCta = () => (
  <div className="mx-auto mt-12 max-w-lg lg:max-w-none">
    <div className="h-4 rounded-t-2xl bg-blue-06" />
    <div className="rounded-b-2xl p-16 text-center shadow-md">
      <Heading3 as="p" className="text-grey-10">
        Hit your number every month
      </Heading3>
      <ButtonExtraLarge as="a" href="/" className="mt-4 inline-block">
        Get Yesware for free
      </ButtonExtraLarge>
      <p className="mt-8 text-grey-06">
        Works on Outlook or Gmail (+ many more integrations)
      </p>
      <div className="mt-6 flex flex-row justify-center gap-x-4">
        <Outlook className="h-12 w-12" alt="Outlook" />
        <Gmail className="h-12 w-12" alt="Gmail" />
        <Salesforce className="h-12 w-12" alt="Salesforce" />
        <LinkedIn className="h-12 w-12" alt="LinkedIn" />
        <Zoom className="h-12 w-12" alt="Zoom" />
        <Teams className="h-12 w-12" alt="Teams" />
      </div>
    </div>
  </div>
);

export default PostCta;
